<app-theme-page-container>
	<app-theme-page-section label="Upload floorplan">

		<p>Upload a floorplan to be added to 4D, acceptable formats are PDF (.pdf), AutoCAD (.cad), SVG or Adobe Illustrator
			(.ai)

		</p>
	</app-theme-page-section>
</app-theme-page-container>
